import { render } from "./ImageSearchTab.vue?vue&type=template&id=15bbc38e&scoped=true"
import script from "./ImageSearchTab.vue?vue&type=script&lang=js"
export * from "./ImageSearchTab.vue?vue&type=script&lang=js"

import "./ImageSearchTab.vue?vue&type=style&index=0&id=15bbc38e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15bbc38e"]])

export default __exports__